import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { debounceTime, forkJoin } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { CandidateListandStatusComponent } from '../candidate-listand-status/candidate-listand-status.component';
import { FormControl } from '@angular/forms';
import { calculateFiscalYear, formatYear } from 'src/app/shared/commen-function-file';
import { MatSelectChange } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { combineLatest } from 'rxjs';
import { delay, distinctUntilChanged, startWith } from 'rxjs/operators';
import { AddEditCandidatePopupComponent } from '../add-edit-candidate-popup/add-edit-candidate-popup.component';

interface PositionPayload {
  companyId: any;
  fiscalYear: any;
  month: any;
  positionCategory: any;
  band: any;
  designation: any;
  positionOpeningDate: any;
  positionClosingDate: any;
  department: any;
  location: any;
  jobPosting: any;
  jobPlatForm: any;
  jobDescription: any;
  panelMembers: { [id: string]: string };
  positionName: any;
  techPosition: any;
  numberOfVacanciesForPosition: any;
  leadInterviewers: { [id: string]: string };
  yearOfExperience: any;
  salaryRange: any;
  skills: any;
  education: any;
  positionLink: any;
  hod: { [id: string]: string };
  positionId?: any;
}
interface JobPlatform {
  jobPlatformId: number;
  jobPlatformCode: string | null;
  jobPlatformName: string | null;
  isDeleted: boolean;
  jobPlatformType: 'Firm' | 'Job Platform';
}
interface Band {
  band: string;
}

@Component({
  selector: 'app-positionrequisitionform',
  templateUrl: './positionrequisitionform.component.html',
  styleUrls: ['./positionrequisitionform.component.scss'],

})
export class PositionrequisitionformComponent implements OnInit {
  positionForm!: FormGroup;
  vacantPositions: any[] = [];
  isEditMode = false;
  categories = ['Vacant Position', 'New Position'];
  bands: Band[] = [];
  filteredBands: Band[] = [];
  departments: any;
  locations: any;
  designations: any;
  jobPostingTypes = ['Internal', 'External'];
  hods: any;
  mds: any;
  approvers: any;
  panelMembers: any;
  userName: any;
  buttonColorName: string | null = null;
  subModuleButtonColor: string | null = null;
  loggedInUserCompanyID: number | null = null;
  loggedInCompanyFiscalyear: any | null = null;
  loggedInUserEmpCode: string | null = null;
  intHODempCode: string | null = null;
  loggedInUserId: string | null = null;
  loggedInUserRole: any | null = null;
  loggedInUserRoles: any[] = [];
  loggedInUserRoleIsEmployee: boolean = false;
  loggedInUserRoleIsMD: boolean = false;
  loggedInCompanyMDCode: string | null = null;
  loggedInCompanyReviewCycle: string | null = null;
  loading: boolean = false;
  isSubmitting: boolean = false;
  filteredDepartments: { department: string }[] = [];
  filteredLocations: { location: string }[] = [];
  filteredDesignations: { designation: string }[] = [];
  filteredJobPlatforms: { key: string, label: string }[] = [];
  positionRequisitionYears: any[] = [];
  selectedYearForRecruitment: string = '';
  fromYear: string = '';
  toYear: string = '';
  taskFromDate: any = null;
  taskToDate: any = null;
  selectedMonth: string = '';
  editingPositionId: string | number | null = null;
  private cachedHODDetails: any[] = [];
  techPositions: any[] = [];
  selectedTechPosition: any;
  isViewMode: boolean = false;
  newPlatformControl = this.fb.control('');              // for input box
  jobPlatformsList: JobPlatform[] = [];
  minClosingDate: Date = new Date(new Date().setDate(new Date().getDate() + 1));
  showAddInput = false;

  arrUserIds: any = [];
  readonly months = [
    { key: '01', name: 'January' }, { key: '02', name: 'February' }, { key: '03', name: 'March' },
    { key: '04', name: 'April' }, { key: '05', name: 'May' }, { key: '06', name: 'June' },
    { key: '07', name: 'July' }, { key: '08', name: 'August' }, { key: '09', name: 'September' },
    { key: '10', name: 'October' }, { key: '11', name: 'November' }, { key: '12', name: 'December' }
  ];

  get arrAllMonths() {
    return this.loggedInCompanyFiscalyear === 'Apr_Mar'
      ? [...this.months.slice(3), ...this.months.slice(0, 3)]
      : this.months;
  }
  constructor(private fb: FormBuilder,
    private httpService: HttpService, private config: Config, private encryptionService: EncryptionService,
    private dataRefreshService: DataRefreshService, public dialog: MatDialog,
    private dialogRef: MatDialogRef<CandidateListandStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef,

  ) { }
  ngOnInit(): void {
    this.initializeSessionData();
    this.getPmsYearList();
    this.isViewMode = this.data?.isViewMode ?? false;

    this.isEditMode = !!this.data?.candidate || !!this.data?.positionRequisitionData?.positionReuisition;

    const positionReuisition = this.data?.positionRequisitionData?.positionReuisition || {};

    this.initForm(positionReuisition);
    combineLatest([
      this.bandControl.valueChanges.pipe(distinctUntilChanged()),
      this.departmentControl.valueChanges.pipe(distinctUntilChanged())
    ])
      .pipe(debounceTime(300))
      .subscribe(([band, department]) => {
        if (band && department) this.fetchHODsByBandAndDepartment();
      });

  }

  onClose(): void {
    this.dialogRef.close();
  }
  initializeSessionData(): void {
    const decrypt = (key: string) => {
      const val = sessionStorage.getItem(key);
      return val ? this.encryptionService.decryptData(val) : null;
    };
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');

    const companyId = sessionStorage.getItem('loggedInUserCompanyID');
    this.loggedInUserCompanyID = companyId ? Number(this.encryptionService.decryptData(companyId)) : null;
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    this.intHODempCode = this.loggedInUserEmpCode;
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    this.loggedInCompanyFiscalyear = decrypt('loggedInCompanyFiscalyear');
    this.loggedInUserRole = decrypt('loggedInUserRole');
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInUserRoleIsEmployee = this.loggedInUserRoles.length === 1 && this.loggedInUserRoles[0].displayName === 'Employee';
    this.loggedInUserRoleIsMD = this.loggedInUserRoles.some((r: any) => r.displayName === 'MD');
    console.log(this.loggedInUserRole, this.loggedInUserRoleIsMD);
    this.userName = sessionStorage.getItem('loggedInUserName');
  }

  getPmsYearList(): void {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.positionRequisitionYears = formatYear(data?.data?.yearRanges, this.loggedInCompanyFiscalyear);
      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const defaultYear = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(defaultYear);
      this.setDefaultMonth();
      this.loadStaticDropdowns();
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.positionRequisitionYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForRecruitment = selectedYearObj.year;
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }

  onYearChange(year: string): void {
    this.selectedYearForRecruitment = year;
    this.taskFromDate = null;
    this.taskToDate = null;
    this.setDefaultMonth();
    this.loadStaticDropdowns();
  }

  setDefaultMonth(): void {
    const currentMonthKey = new Date().toISOString().slice(5, 7);
    const found = this.arrAllMonths.find(m => m.key === currentMonthKey);
    this.selectedMonth = found ? found.key : this.arrAllMonths[0].key;
  }

  onMonthChange(event: MatSelectChange): void {
    this.selectedMonth = event.value;
    this.loadStaticDropdowns();
  }

  private loadStaticDropdowns(): void {
    const category = this.positionForm.get('positionCategory')?.value || '';
    const band = this.bandControl.value || '';

    this.fetchBandsByCompanyID(category);
    this.fetchDepartmentsByCompanyID(category, band);
    this.fetchHodDetailsByCompanyID();
    this.fetchApproversByCompanyID();
    this.fetchLocationDetailsByCompanyID();
    this.fetchEmployeeDetailsByCompanyID();
    this.fetchDesignationsByCompanyID();
    this.setupBandAutocomplete();
    this.loadTechPositions();
    this.fetchJobPlatforms();
  }
  private initForm(positionRequisition: any = {}): void {
    this.positionForm = this.fb.group({
      positionCategory: [{ value: '', disabled: this.isViewMode }, Validators.required],
      band: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(100)]],
      designation: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(100)]],
      positionOpenDate: [{ value: this.isEditMode ? null : new Date(), disabled: this.isViewMode }, Validators.required],
      positionClosingDate: [{ value: new Date(), disabled: this.isViewMode }, Validators.required],
      techPosition: [{ value: '', disabled: this.isViewMode }, Validators.required],
      department: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(100)]],
      location: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(100)]],
      jobPosting: [{ value: [], disabled: this.isViewMode }, Validators.required],
      jobPlatforms: [{ value: [], disabled: this.isViewMode }],
      hodIdList: [{ value: [], disabled: this.isViewMode }],
      jobDescription: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(2000)]],
      positionName: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(100)]],
      numberOfVacancies: [{ value: 1, disabled: this.isViewMode }, [Validators.required, Validators.min(1), Validators.pattern(/^\d+$/)]],
      experienceYears: [{ value: null, disabled: this.isViewMode }, [Validators.required, Validators.min(0), Validators.max(99)]],
      salaryRange: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(50)]],
      skills: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(200)]],
      education: [{ value: '', disabled: this.isViewMode }, [Validators.required, Validators.maxLength(200)]],
      positionCreatedById: [null],
      positionCreatedByName: [null],
      positionCreatedByUserRole: [null],
      interviewPanelMembers: [{ value: [], disabled: this.isViewMode }, Validators.required],
      leadInterviewer: [{ value: [], disabled: this.isViewMode }, Validators.required]
    });

    // Parse and transform
    const jobPosting = typeof positionRequisition?.jobPosting === 'string'
      ? positionRequisition.jobPosting.split(',').map((x: string) => x.trim())
      : positionRequisition?.jobPosting ?? [];

    const jobPlatforms =
      Array.isArray(positionRequisition?.jobPlatForm)
        ? positionRequisition.jobPlatForm.map((x: any) => x.trim())
        : typeof positionRequisition?.jobPlatForm === 'string'
          ? positionRequisition.jobPlatForm.split(',').map((x: string) => x.trim())
          : [];



    if (this.isEditMode && positionRequisition?.id) {
      this.editingPositionId = positionRequisition.id;
      // this.patchDepartmentAndHOD(positionRequisition);
    }

    if (this.isEditMode && positionRequisition?.hod && Object.keys(positionRequisition.hod).length > 0) {
      this.cachedHODDetails = Object.entries(positionRequisition.hod).map(([hod_id, hod_name]) => ({ hod_id, hod_name }));
    }

    const patchData = {
      ...positionRequisition,
      positionOpenDate: this.isEditMode && positionRequisition.positionOpeningDate
        ? new Date(positionRequisition.positionOpeningDate)
        : new Date(),
      positionClosingDate: positionRequisition.positionClosingDate ? new Date(positionRequisition.positionClosingDate) : null,
      numberOfVacancies: positionRequisition.numberOfVacanciesForPosition || 1,
      experienceYears: parseInt(positionRequisition.yearOfExperience) || 0,
      jobPosting,
      jobPlatforms,
      leadInterviewer: [],
      interviewPanelMembers: [],
      hodIdList: this.cachedHODDetails || []
    };
    this.positionForm.patchValue(patchData, { emitEvent: false });
    // Special handling for positionName
    if (positionRequisition?.positionCategory === 'Vacant Position') {
      this.loadVacantPositions(positionRequisition.positionName);
    } else {
      this.positionForm.patchValue(
        { positionName: positionRequisition?.positionName || '' },
        { emitEvent: false }
      );
    }
    combineLatest([
      this.positionForm.get('positionCategory')!.valueChanges.pipe(startWith(this.positionForm.get('positionCategory')!.value)),
      this.bandControl.valueChanges.pipe(startWith(this.bandControl.value))
    ])
      .pipe(distinctUntilChanged((a, b) => a[0] === b[0] && a[1] === b[1]))

      .subscribe(([category, band]) => {
        this.departments = [];
        this.filteredDepartments = [];

        this.fetchBandsByCompanyID(category);

        if (category === 'Vacant Position') {
          this.loadVacantPositions(this.positionForm.get('positionName')?.value);
        }
        if (category === 'Vacant Position' || band) {
          this.fetchDepartmentsByCompanyID(category, band);
        }
      });

    this.positionForm.get('positionName')?.valueChanges.subscribe(selectedPos => {
      if (this.positionForm.get('positionCategory')?.value === 'Vacant Position' && selectedPos) {
        // Patch same value into designation
        this.positionForm.get('designation')?.setValue(selectedPos);
      }
    });

    /** ---------- Reset form on category change ---------- **/
    this.positionForm.get('positionCategory')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((selectedCategory) => {
        if (selectedCategory) {
          // ✅ Preserve important fields before reset
          const preserved = {
            editingPositionId: this.editingPositionId,
            positionCreatedById: this.positionForm.get('positionCreatedById')?.value,
            positionCreatedByName: this.positionForm.get('positionCreatedByName')?.value,
            positionCreatedByUserRole: this.positionForm.get('positionCreatedByUserRole')?.value
          };

          const currentCategory = selectedCategory;

          // Reset entire form but keep preserved fields
          this.positionForm.reset({
            ...preserved,
            positionCategory: currentCategory,
            positionOpenDate: new Date(),
            numberOfVacancies: 1,
            experienceYears: 0
          });

          // Optional logic after reset
          if (currentCategory === 'Vacant Position') {
            this.loadVacantPositions('');
          }

          if (this.isViewMode) this.positionForm.disable();
        }
      });

  }
  private patchDepartmentAndHOD(positionRequisition: any) {
    const category = positionRequisition.positionCategory || '';
    const band = positionRequisition.band || '';
    const department = positionRequisition.department || '';
    console.log('🔹 patchDepartmentAndHOD called with:', { category, band, department });

    this.fetchDepartmentsByCompanyID(category, band, true, department);
  }

  private loadVacantPositions(selectedName?: string): void {
    const url = `${this.config.getVacantPositions}?companyId=${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(url).subscribe({
      next: (res: any) => {
        this.vacantPositions = (res || []).map((p: any) => ({
          ids: p.ids,
          name: p['position name']
        }));

        // ✅ Patch positionName once options are ready
        if (selectedName) {
          const match = this.vacantPositions.find(p => p.name === selectedName);
          if (match) {
            this.positionForm.patchValue(
              { positionName: match.name },
              { emitEvent: false }
            );
          }
        }
      },
      error: (err) => console.error('❌ Error loading vacant positions:', err)
    });
  }

  onExperienceInput(event: Event): void {
    const input = (event.target as HTMLInputElement);
    if (input.value.length > 2) {
      input.value = input.value.slice(0, 2);
      this.positionForm.get('experienceYears')?.setValue(+input.value);
    }
  }

  onReset() {
    this.positionForm.reset({
      positionOpenDate: new Date(),
      jobPlatforms: [],
    });
  }
  get jobPlatformsControl(): FormControl {
    return this.positionForm.get('jobPlatforms') as FormControl;
  }

  onPlatformChange(checked: boolean, key: string) {
    const platforms = [...(this.positionForm.get('jobPlatforms')?.value || [])];

    if (checked && !platforms.includes(key)) {
      platforms.push(key);
    } else if (!checked) {
      const index = platforms.indexOf(key);
      if (index > -1) {
        platforms.splice(index, 1);
      }
    }

    this.positionForm.get('jobPlatforms')?.setValue(platforms);
  }

  private loadTechPositions(): void {
    // const url = `${this.config.getAllTechPositions}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForRecruitment}&month=${Number(this.selectedMonth)}`;
    const url = `${this.config.getAllTechPositions}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForRecruitment}`;

    this.httpService.callGetService(url).subscribe({
      next: (res: any) => {
        this.techPositions = (res || []).map((p: string) => ({ name: p })).sort((a: any, b: any) => a.name.localeCompare(b.name));
        const patchValue = this.data?.positionRequisitionData?.positionReuisition?.techPosition;
        if (patchValue) {
          this.positionForm.get('techPosition')?.setValue(patchValue);
        }
      },
      error: (err) => console.error('❌ Error loading tech positions:', err)
    });
  }
  onSubmit(): void {
    if (this.isSubmitting) {
      return; // Prevent double submission
    }

    if (this.positionForm.valid) {
      this.isSubmitting = true;
      this.loading = true;
      // Utility Function
      const formatDate = (date: Date): string => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
      };
      // Form Value Extraction
      const formValue = this.positionForm.value;

      const jobPlatForm = Array.isArray(formValue.jobPlatforms)
        ? formValue.jobPlatforms.join(', ')
        : formValue.jobPlatforms;

      const jobPosting = Array.isArray(formValue.jobPosting)
        ? formValue.jobPosting.join(', ')
        : formValue.jobPosting;

      const selectedHODs = formValue.hodIdList || [];
      const hod = selectedHODs.reduce((acc: any, h: any) => {
        acc[h.hod_id] = h.hod_name;
        return acc;
      }, {});

      const panelMembers = Array.isArray(formValue.interviewPanelMembers)
        ? formValue.interviewPanelMembers.reduce((acc: any, m: any) => {
          acc[m.id] = m.name;
          return acc;
        }, {})
        : {};

      const leadInterviewers = Array.isArray(formValue.leadInterviewer)
        ? formValue.leadInterviewer.reduce((acc: any, interviewer: any) => {
          acc[interviewer.id] = interviewer.name;
          return acc;
        }, {})
        : {};

      // 🌐 Dynamic Position Link Generation
      let positionLink = '';

      // Payload Construction
      const payload: PositionPayload = {
        companyId: this.loggedInUserCompanyID,
        fiscalYear: this.selectedYearForRecruitment,
        month: this.selectedMonth,
        positionCategory: formValue.positionCategory,
        band: formValue.band,
        designation: formValue.designation,
        positionOpeningDate: formatDate(formValue.positionOpenDate),
        positionClosingDate: formValue.positionClosingDate ? formatDate(formValue.positionClosingDate) : null,
        department: formValue.department,
        location: formValue.location,
        jobPosting: jobPosting,
        jobPlatForm: jobPlatForm,
        jobDescription: formValue.jobDescription,
        hod: hod,
        panelMembers: panelMembers,
        positionName: formValue.positionName,
        techPosition: formValue.techPosition,
        numberOfVacanciesForPosition: formValue.numberOfVacancies,
        leadInterviewers: leadInterviewers,
        yearOfExperience: formValue.experienceYears,
        salaryRange: formValue.salaryRange,
        skills: formValue.skills,
        positionLink: positionLink,
        education: formValue.education,
        ...(this.isEditMode && this.editingPositionId
          ? {
            positionId: this.editingPositionId,
            positionCreatedById: formValue.positionCreatedById,
            positionCreatedByName: formValue.positionCreatedByName,
            positionCreatedByUserRole: formValue.positionCreatedByUserRole
          }
          : {
            positionCreatedById: this.loggedInUserId,
            positionCreatedByName: this.userName,
            positionCreatedByUserRole: this.loggedInUserRole
          })
      };

      console.log('✅ Form is valid', formValue);
      console.log('📦 Payload:', payload);
      // API Call
      const endpoint = this.isEditMode
        ? `${this.config.updatePositionRequestUrl}/${this.editingPositionId}`
        : this.config.savePositionRequestUrl;

      const request$ = this.isEditMode
        ? this.httpService.callPutService(endpoint, payload)
        : this.httpService.callPostService(endpoint, [payload]);

      request$.subscribe({
        next: (result: any) => {
          console.log('✅ API Response:', result);
          this.toastr.success(
            this.isEditMode
              ? 'The Position Requisition has been updated successfully.'
              : 'The Position Requisition has been saved successfully.'
          );
          this.dataRefreshService.triggerRefresh();
          this.dialogRef.close();
          this.loading = false;
          this.isSubmitting = false;
        },
        error: (err: any) => {
          console.error('❌ Error saving/updating position requisition:', err);
          this.toastr.error(
            this.isEditMode
              ? 'Failed to update the Position Requisition.'
              : 'Failed to save the Position Requisition.'
          );
          this.loading = false;
          this.isSubmitting = false;
        }
      });

    } else {
      // Invalid Form Handling
      this.positionForm.markAllAsTouched();

      const invalidFields = Object.entries(this.positionForm.controls)
        .filter(([_, control]) => control.invalid)
        .map(([key, control]) => ({
          key,
          errors: control.errors
        }));

      console.warn('⚠️ Form is invalid');
      console.table(invalidFields);
    }
  }

  getListOfBandName: any = [];

  fetchBandsByCompanyID(category: string): void {
    let userIdsString = '';
    const hasMD = this.loggedInUserRoles.some(r => r.displayName === 'MD');

    // Determine user IDs to pass based on role
    if ((this.loggedInUserRole === 'HOD') && !hasMD) {
      userIdsString = this.loggedInUserId ?? '';
    } else if (!hasMD && this.arrUserIds?.length > 0) {
      userIdsString = this.arrUserIds.join(',');
    }

    // Build API URL
    const apiUrl = userIdsString
      ? `${this.config.getBandDetails}?companyId=${this.loggedInUserCompanyID}&positionCategory=${category}&userHodIds=${userIdsString}`
      : `${this.config.getBandDetails}?companyId=${this.loggedInUserCompanyID}&positionCategory=${category}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (data: any) => {
        this.bands = (data?.data || []).map((ele: string) => ({ band: ele }))
          .sort((a: any, b: any) => a.band.localeCompare(b.band));
        this.filteredBands = [...this.bands];
      },
      error: (err) => {
        console.error('Error fetching bands:', err);
      }
    });
  }
  fetchDepartmentsByCompanyID(category: string, band: string, patchMode: boolean = false, patchDepartment?: string): void {

    let userIdsString = '';
    const hasMD = this.loggedInUserRoles.some(r => r.displayName === 'MD');

    if ((this.loggedInUserRole === 'HOD') && !hasMD) {
      userIdsString = this.loggedInUserId ?? '';
    } else if (!hasMD && this.arrUserIds?.length > 0) {
      userIdsString = this.arrUserIds.join(',');
    }

    const apiUrl = userIdsString
      ? `${this.config.getDepartmentDetails}?companyId=${this.loggedInUserCompanyID}&positionCategory=${category}&band=${band}&userHodIds=${userIdsString}`
      : `${this.config.getDepartmentDetails}?companyId=${this.loggedInUserCompanyID}&positionCategory=${category}&band=${band}`;

    this.httpService.callGetService(apiUrl).subscribe({
      next: (data: any) => {
        this.departments = (data?.data || []).map((d: any) => ({ department: d })).sort((a: any, b: any) => a.department.localeCompare(b.department));
        this.filteredDepartments = [...this.departments];
        this.departmentControl.setValue('');
        console.log('🔹 Departments loaded:', this.departments);

        if (patchMode && patchDepartment) {
          const match = this.departments.find((d: any) => d.department === patchDepartment);
          if (match) {
            this.departmentControl.setValue(match.department, { emitEvent: true });
            console.log('🔹 Department patched:', this.departmentControl.value);
            this.fetchHODsByBandAndDepartment(true); // patch HODs after department is set
          }
        }
      },
      error: (err) => console.error('Error fetching departments:', err)
    });
  }

  fetchDesignationsByCompanyID(): void {
    const apiUrl = `${this.config.getDesignationDetails}?companyId=${this.loggedInUserCompanyID}`; // Replace ${this.loggedInUserCompanyID} with dynamic ID if needed

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.designations = (data?.data || []).map((ele: string) => ({ designation: ele }))
            .sort((a: any, b: any) => a.designation.localeCompare(b.designation));
          this.filteredDesignations = [...this.designations];
        },
        error: (err) => {
          console.error('Error fetching designations:', err);
        }
      });
  }

  fetchHodDetailsByCompanyID(): void {
    const apiUrl = `${this.config.positionRequestedByHOD}?companyId=${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.hods = (data?.data || []).map((ele: any) => ({ hod: ele }))
            .sort((a: any, b: any) => a.hod.localeCompare(b.hod));
        },
        error: (err) => {
          console.error('Error fetching HODs:', err);
        }
      });
  }
  fetchMdDetailsByCompanyID(): void {
    const apiUrl = `${this.config.getMdDetails}?companyId=${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.mds = (data?.data || []).map((ele: any) => ({ md: ele }))
            .sort((a: any, b: any) => a.md.localeCompare(b.md));
        },
        error: (err) => {
          console.error('Error fetching MDs:', err);
        }
      });
  }

  fetchApproversByCompanyID(): void {
    const companyId = this.loggedInUserCompanyID;
    const hodUrl = `${this.config.positionRequestedByHOD}?companyId=${companyId}`;
    const mdUrl = `${this.config.getMdDetails}?companyId=${companyId}`;

    const hodRequest = this.httpService.callGetService(hodUrl);
    const mdRequest = this.httpService.callGetService(mdUrl);

    forkJoin([hodRequest, mdRequest]).subscribe({
      next: ([hodData, mdData]: [any, any]) => {
        const hods = hodData?.data || [];
        const mds = mdData?.data || [];
        this.approvers = [...hods, ...mds].sort((a, b) => a.localeCompare(b));
      },
      error: (err) => {
        console.error('Error fetching approvers:', err);
      }
    });
  }
  filteredHODs: any[] = [];

  fetchHODsByBandAndDepartment(isPatchMode: boolean = false): void {
    const band = this.positionForm.get('band')?.value?.trim();
    const department = this.positionForm.get('department')?.value?.trim();

    if (band && department) {
      const encodedDepartment = encodeURIComponent(department);
    const encodedBand = encodeURIComponent(band);

    const url = `${this.config.getHODByBandDepts}?companyId=${this.loggedInUserCompanyID}&department=${encodedDepartment}&band=${encodedBand}`;

      // const url = `${this.config.getHODByBandDepts}?companyId=${this.loggedInUserCompanyID}&department=${department}&band=${band}`;

      this.httpService.callGetService(url).subscribe({
        next: (res: any) => {
          this.filteredHODs = Array.isArray(res) ? res : res?.data || [];

          // ✅ Patch full HOD objects if in edit mode
          if (isPatchMode && this.cachedHODDetails?.length) {
            const selectedIds = this.cachedHODDetails.map((h: any) => h.hod_id);
            const matchedHODs = this.filteredHODs.filter((h: any) =>
              selectedIds.includes(h.hod_id)
            );

            this.positionForm.patchValue({
              hodIdList: matchedHODs
            });
          }
        },
        error: (err: any) => {
          console.error('❌ Failed to fetch HODs:', err);
          this.filteredHODs = [];

          // Optionally clear selection
          this.positionForm.patchValue({
            hodIdList: []
          });
        }
      });
    }
  }

  fetchLocationDetailsByCompanyID(): void {
    const apiUrl = `${this.config.getLocationDetails}?companyId=${this.loggedInUserCompanyID}`;

    this.httpService.callGetService(apiUrl)
      .subscribe({
        next: (data: any) => {
          this.locations = (data?.data || []).map((ele: any) => ({ location: ele }))
            .sort((a: any, b: any) => a.location.localeCompare(b.location));
          this.filteredLocations = [...this.locations];
        },
        error: (err) => {
          console.error('Error fetching locations:', err);
        }
      });
  }
  private fetchEmployeeDetailsByCompanyID(): void {
    const apiUrl = `${this.config.getRecruitmentEmployeeDetails}?companyId=${this.loggedInUserCompanyID}`;
    this.httpService.callGetService(apiUrl).subscribe({
      next: (res: any) => {
        const data = res?.data || [];
        this.panelMembers = data.map((emp: any) => ({ id: emp.employee_id, name: emp.fullName }))
          .sort((a: any, b: any) => a.name.localeCompare(b.name));

        const req = this.data?.positionRequisitionData?.positionReuisition;
        if (this.isEditMode && req) {
          console.log(req);

          if (req.leadInterviewers) {
            const patchedLeadInterviewers = Object.entries(req.leadInterviewers).map(([id, name]) => {
              return this.panelMembers.find((p: any) => p.id == +id) || { id: +id, name };
            });
            this.positionForm.get('leadInterviewer')?.setValue(patchedLeadInterviewers);
          }

          if (req.panelMembers) {
            let patchedPanel: any[] = [];

            if (typeof req.panelMembers === 'string') {
              // Case 1: API sends comma-separated names
              const names = req.panelMembers.split(',').map((n: any) => n.trim());
              patchedPanel = this.panelMembers.filter((p: any) => names.includes(p.name));
            }
            else if (Array.isArray(req.panelMembers)) {
              // Case 2: API sends array of names
              patchedPanel = req.panelMembers.map((name: string) =>
                this.panelMembers.find((p: any) => p.name === name) || { id: null, name }
              );
            }
            else if (typeof req.panelMembers === 'object') {
              const entries = Object.entries(req.panelMembers);

              if (entries.every(([key]) => !isNaN(+key))) {
                // Case 3: Keys are numeric indexes -> match by NAME
                patchedPanel = entries.map(([_, name]) =>
                  this.panelMembers.find((p: any) => p.name === name) || { id: null, name }
                );
              } else {
                // Case 4: Keys are real IDs -> match by ID
                patchedPanel = entries.map(([id, name]) =>
                  this.panelMembers.find((p: any) => p.id == +id) || { id: +id, name }
                );
              }
            }

            this.positionForm.get('interviewPanelMembers')?.setValue(patchedPanel);

          }
          // Then patch department & HOD
          const category = req.positionCategory || '';
          const band = req.band || '';
          const savedDepartment = req.department;

          if (category && band && savedDepartment) {
            this.fetchDepartmentsByCompanyID(category, band, true, savedDepartment);
          }
        }
      },
      error: (err) => console.error('❌ Error fetching employee details:', err)
    });
  }
  fetchJobPlatforms(): void {
    // const url = `${this.config.getJobPlatforms}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForRecruitment}&month=${this.selectedMonth}`;
    const url = `${this.config.getJobPlatforms}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForRecruitment}`;

    this.httpService.callGetService(url).subscribe({
      next: (res: any) => {
        let data: JobPlatform[] = res || [];

        data = data
          .filter((x: any) => !x.isDeleted)
          .map((x: any) => ({
            ...x,
            jobPlatformType: x.jobPlatformCode ? 'Firm' : 'Job Platform'
          }));

        this.jobPlatformsList = data;
      },
      error: err => {
        console.error('Error fetching Job Platforms:', err);
        this.toastr.error('Failed to fetch Job Platforms.', 'Error');
      }
    });
  }

  newPlatformName = '';


  confirmAddPlatform(): void {
    const name = this.newPlatformControl.value?.trim();
    if (!name) return;

    const newCode = `CUSTOM_${Date.now()}`;
    const newLabel = name;

    this.filteredJobPlatforms.push({ key: newCode, label: newLabel });

    // Select newly added
    const current = this.jobPlatformsControl.value || [];
    this.jobPlatformsControl.setValue([...current, newCode]);

    this.newPlatformControl.reset();
    this.showAddInput = false;
  }

  cancelAddPlatform(): void {
    this.newPlatformControl.reset();
    this.showAddInput = false;
  }

  cancel(): void {
    this.dialogRef.close();
  }
  compareFn = (a: any, b: any) => a?.id === b?.id;
  compareHodFn = (a: any, b: any) => a?.hod_id === b?.hod_id;

  setupBandAutocomplete(): void {
    this.positionForm.get('band')?.valueChanges
      .pipe(debounceTime(200)) // optional: add import from rxjs/operators
      .subscribe(value => {
        const input = (value || '').toLowerCase();
        this.filteredBands = this.bands?.filter((b: any) =>
          b.band.toLowerCase().includes(input)
        );
      });
  }
  onBandBlur(): void {
    const category = this.positionForm.get('positionCategory')?.value;
    const enteredValue = this.bandControl.value?.trim();

    // Prevent manual entry for Vacant Position
    if (category === 'Vacant Position' && !this.bands.some(b => b.band === enteredValue)) {
      this.bandControl.setValue('');
      return;
    }

    if (!enteredValue) return;

    const exists = this.bands.some(b => b.band.toLowerCase() === enteredValue.toLowerCase());
    if (!exists) {
      this.bands.push({ band: enteredValue });
      this.bands.sort((a, b) => a.band.localeCompare(b.band));
      this.filteredBands = [...this.bands];
    }
  }


  get bandControl(): FormControl {
    return this.positionForm.get('band') as FormControl;
  }
  setupDepartmentAutocomplete(): void {
    this.departmentControl.valueChanges.pipe(debounceTime(200)).subscribe(value => {
      const input = (value || '').toLowerCase();
      this.filteredDepartments = this.departments?.filter((d: any) => d.department.toLowerCase().includes(input));
    });
  }

  onDepartmentBlur(): void {
    const category = this.positionForm.get('positionCategory')?.value;
    const enteredValue = this.departmentControl.value?.trim();

    if (category === 'Vacant Position') {
      const exists = this.departments.some((d: any) => d.department === enteredValue);
      if (!exists) this.departmentControl.setValue('');
      return;
    }

    // allow manual addition for New Position
    if (category === 'New Position' && enteredValue) {
      const exists = this.departments.some((d: any) => d.department.toLowerCase() === enteredValue.toLowerCase());
      if (!exists) {
        this.departments.push({ department: enteredValue });
        this.departments.sort((a: any, b: any) => a.department.localeCompare(b.department));
        this.filteredDepartments = [...this.departments];
      }
    }
  }


  get departmentControl(): FormControl {
    return this.positionForm.get('department') as FormControl;
  }
  get locationControl(): FormControl {
    return this.positionForm.get('location') as FormControl;
  }
  setupLocationAutocomplete(): void {
    this.positionForm.get('location')?.valueChanges
      .pipe(debounceTime(200))
      .subscribe(value => {
        const input = (value || '').toLowerCase();
        this.filteredLocations = this.locations?.filter((l: any) =>
          l.location.toLowerCase().includes(input)
        );
      });
  }
  onLocationBlur(): void {
    const enteredValue = this.positionForm.get('location')?.value?.trim();
    if (
      enteredValue &&
      !this.locations?.some((l: { location: string }) => l.location.toLowerCase() === enteredValue.toLowerCase())
    ) {
      this.locations.push({ location: enteredValue });
      this.locations.sort((a: { location: string }, b: { location: string }) => a.location.localeCompare(b.location));
    }
  }
  get designationControl(): FormControl {
    return this.positionForm.get('designation') as FormControl;
  }
  setupDesignationAutocomplete(): void {
    this.positionForm.get('designation')?.valueChanges
      .pipe(debounceTime(200))
      .subscribe(value => {
        const input = (value || '').toLowerCase();
        this.filteredDesignations = this.designations?.filter((d: any) =>
          d.designation.toLowerCase().includes(input)
        );
      });
  }
  onDesignationBlur(): void {
    const enteredValue = this.positionForm.get('designation')?.value?.trim();
    if (
      enteredValue &&
      !this.designations?.some((d: { designation: string }) =>
        d.designation.toLowerCase() === enteredValue.toLowerCase()
      )
    ) {
      this.designations.push({ designation: enteredValue });
      this.designations.sort((a: { designation: string }, b: { designation: string }) => a.designation.localeCompare(b.designation));
    }
  }
  onApply() {
    // Add your logic here for applying (e.g., navigate, emit event, service call)
    console.log('Apply Now clicked');
    this.dialogRef.close();
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.height = '70%';
    config.width = '70%';
    config.panelClass = 'custom-dialog-container';
    config.data = {};

    const dialogRef = this.dialog.open(AddEditCandidatePopupComponent, config);
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
